import { render, staticRenderFns } from "./WorkerProfile.vue?vue&type=template&id=cbbbafe8&"
import script from "./WorkerProfile.vue?vue&type=script&lang=js&"
export * from "./WorkerProfile.vue?vue&type=script&lang=js&"
import style0 from "./WorkerProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports